import { getEmojiColorPalette } from "@/components/emoji/emoji-colors.ts";
import { useMemo } from "react";

interface GradientContainerProps {
  emoji?: string;
  colorPalette?: string[];
  addLightOverlayTop?: boolean;
  addLightOverlayToBottom?: boolean;
}

export const GradientContainer = ({
  emoji,
  colorPalette,
  addLightOverlayTop,
  addLightOverlayToBottom,
}: GradientContainerProps) => {
  const emojiColors = useMemo(() => (emoji ? getEmojiColorPalette(emoji) : undefined), [emoji]);

  const innerColoPalette = emojiColors ? emojiColors : colorPalette;
  if (!innerColoPalette) {
    return null;
  }

  const gradientStyle = {
    background: `radial-gradient(ellipse farthest-corner at 0% 100%, #${innerColoPalette[0]} 0%, #${innerColoPalette[1]} 100%)`,
  };

  return (
    <>
      <div style={gradientStyle} className={"top-0 left-0 right-0 h-full z-0 absolute"} />
      {addLightOverlayTop && (
        <div
          className={"top-0 left-0 right-0 h-full z-0 absolute"}
          style={{
            background:
              "linear-gradient(180deg, color-mix(in srgb, var(--color-light) 60%, transparent) 0%, color-mix(in srgb, var(--color-light) 0%, transparent) 100%)",
          }}
        ></div>
      )}
      {addLightOverlayToBottom && (
        <div
          className={"top-0 left-0 right-0 h-full z-0 absolute"}
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, var(--color-brand-light) 90%)",
          }}
        ></div>
      )}
      {/*{addBlur && (*/}
      {/*  <div*/}
      {/*    className={"top-0 left-0 right-0 h-full z-0 absolute"}*/}
      {/*    style={{*/}
      {/*      backdropFilter: "blur(20px)",*/}
      {/*      zIndex: 1,*/}
      {/*    }}*/}
      {/*  ></div>*/}
      {/*)}*/}
    </>
  );
};
